import React from "react";
import { colors, colors2, UI_BODY_SEMIBOLD_DF } from "oolib";

const CHUNK_RELOAD_KEY = "chunk_error_reload";

function isChunkLoadError(error) {
  const message = error?.message || "";
  return (
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module") ||
    message.includes("Importing a module script failed") ||
    error?.name === "ChunkLoadError"
  );
}

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
      // Flag chunk-load errors so render can show a benign "loading" state
      // (rather than the red "Something went wrong" box) while we reload.
      return { hasError: true, error, isChunkLoadError: isChunkLoadError(error) };
    }

    componentDidCatch(error, errorInfo) {
      console.log({error, errorInfo});

      if (isChunkLoadError(error)) {
        const lastReload = sessionStorage.getItem(CHUNK_RELOAD_KEY);
        const now = Date.now();
        // Only auto-reload if we haven't reloaded in the last 10 seconds
        // (prevents infinite reload loops if the chunk genuinely doesn't exist)
        if (!lastReload || now - Number(lastReload) > 10000) {
          sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
          window.location.reload();
          return;
        }
        // Reload was suppressed (loop guard): the chunk genuinely can't be
        // fetched, so fall back to the normal error UI instead of hanging on
        // the "loading" screen forever.
        this.setState({ isChunkLoadError: false });
      }
    }
    render() {
      if (this.state.hasError) {
        // Deployment updated the chunks: show plain text on white while the
        // page reloads onto the latest build, instead of a scary error.
        if (this.state.isChunkLoadError) {
          return (
            <div style={{padding: '2rem', backgroundColor: colors.white, minHeight: '100vh'}}>
              <UI_BODY_SEMIBOLD_DF>{'Loading latest product version...'}</UI_BODY_SEMIBOLD_DF>
            </div>
          )
        }
        return this.props.ErrorComp ||
        <div style={{padding: '2rem', border: `1px solid ${colors2.red}` }}>
            <UI_BODY_SEMIBOLD_DF color={colors2.redText}>{'Something went wrong.'}</UI_BODY_SEMIBOLD_DF>
        </div>
      }
      return this.props.children;
    }
  }

  export default ErrorBoundary;